module.exports = __webpack_public_path__ + "img/1440.08314578.jpg";